module.exports = __webpack_public_path__ + "static/media/_aland-islands.32761e56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_aland-islands.svg
// module id = 2299
// module chunks = 7